"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trie = void 0;
class Trie {
    map = {};
    isWord = false;
    insert(word) {
        this.add(word, 0, this);
    }
    search(word) {
        return this.find(word, 0, this);
    }
    loadDomainsFromFile(fileContent) {
        const domains = fileContent.split('\n');
        for (const domain of domains) {
            this.insert(domain.trim());
        }
    }
    add(word, index, letterMap) {
        if (index === word.length) {
            letterMap.isWord = true;
            return;
        }
        if (!letterMap.map[word.charAt(index)]) {
            letterMap.map[word.charAt(index)] = new Trie();
        }
        return this.add(word, index + 1, letterMap.map[word.charAt(index)]);
    }
    find(word, index, letterMap) {
        if (index === word.length) {
            return letterMap.isWord;
        }
        if (letterMap.map[word[index]]) {
            return this.find(word, index + 1, letterMap.map[word.charAt(index)]);
        }
        return false;
    }
}
exports.Trie = Trie;
